module.exports = __webpack_public_path__ + "static/media/viroQVideoThumbnail.972cb97a.png";